import React, { useState, useEffect } from 'react';
import $ from 'jquery/dist/jquery.min.js';
import GoogleMapReact from 'google-map-react';
//import { MarkerIcon } from '@components/icon/icon';
import Marker from '../marker/resultsmarker';
import _ from "lodash"
import { InfoBox } from '@react-google-maps/api';

function MapsInfiniteHits(props) {

    const [mapenable, setMapenable] = useState(true);
    const [obList, setObList] = useState([]);
    const [render, setRender] = useState(false);

    const [mapmarkers, setMapmarkers] = useState([]);

    const [center, setCenter] = React.useState({ lat: 54.4223179, lng: -6.5447354 });
    const [zoom, setZoom] = React.useState(11);

    const [currentId, setCurrentId] = React.useState("");

    const ptype = props.ptype

    const update = () => {
        setCenter({ lat: 54.4223179, lng: -6.5447354 });
    };


    useEffect(() => {
        var mapmarkersarr = [];
        const myObserverWhenMyNodeExist = () => {
            //if (typeof window === "undefined" || !window.document) 
            // {
                var targetNode = document.getElementById('property_list_results');//document.getElementById('property_list_results');//$('#property_list_results')[0];//
                if (!targetNode) {
                    //node not exist try again
                    window.setTimeout(myObserverWhenMyNodeExist, 500);
                    return;
                }
              
                // Options for the observer (which mutations to observe)
                var config = { attributes: true, childList: true, subtree: true };
              
                // Callback function to execute when mutations are observed
                var callback = function (mutations, observer) {
                    setMapenable(false)
                    update();
                    mapmarkersarr.length = 0;
                    // Use traditional 'for loops' for IE 11
                    setMapmarkers([]);
                    var myNodeList = document.querySelectorAll(".mysingleproperty");
                    if (myNodeList.length > 0) {
                        _.forEach(myNodeList, function (value, index) {
                            if (typeof value.getAttribute("data-lat") !== "undefined") {
                                mapmarkersarr.push({ objectid: "#" + ptype + value.getAttribute("data-objectid"), lat: value.getAttribute("data-lat"), lng: value.getAttribute("data-lng") })

                            }
                        });
                       

                    }
                    if (mapmarkersarr.length <= 0) {
                        mapmarkersarr.push({ objectid: "noProp", lat: 52.837137, lng: -2.08252 })
                        mapmarkersarr.push({ objectid: "noProp", lat: 52.711729, lng: -2.797567 })
                      } if (mapmarkersarr.length <= 4) {
                        mapmarkersarr.push({ objectid: "noProp", lat: parseFloat(mapmarkersarr[0].lat) + 0.002, lng: parseFloat(mapmarkersarr[0].lng) + 0.002 })
                        mapmarkersarr.push({ objectid: "noProp", lat: parseFloat(mapmarkersarr[0].lat) - 0.003, lng: parseFloat(mapmarkersarr[0].lng) - 0.003 })
                
                      }
                      setMapmarkers(mapmarkers => mapmarkersarr);
                    //setMapmarkers(mapmarkersarr);
                    //console.log(mapmarkers)
                   // setMapenable(Math.floor(Math.random() * 100) + 1);
                    setZoom(12)
                    setTimeout(() => {
                        setMapenable(true)
                    }, 100) 
                };

                // Create an observer instance linked to the callback function
                var observer = new MutationObserver(callback);

                // Start observing the target node for configured mutations
                observer.observe(targetNode, config);
            // }
        } 
        myObserverWhenMyNodeExist();
    }, [])
    // Return map bounds based on list of places
    const mygetMapBounds = (map, maps, places) => {
        const bounds = new maps.LatLngBounds();

        places.forEach((place) => {
            bounds.extend(new maps.LatLng(
                place.lat,
                place.lng,
            ));
        });
        return bounds;
    };

    // Re-center map when resizing the window
    const mybindResizeListener = (map, maps, bounds) => {
        maps.event.addDomListenerOnce(map, 'idle', () => {
            maps.event.addDomListener(window, 'resize', () => {
                map.fitBounds(bounds);
            });
        });
    };

    // Fit map to its bounds after the api is loaded
    const myapiHasLoaded = (map, maps, places) => {
        // Get bounds by our places
        const bounds = mygetMapBounds(map, maps, places);
        // Fit map to bounds
        map.fitBounds(bounds);
        // Bind the resize listener
        mybindResizeListener(map, maps, bounds);
    };

    return (
        <div id="map" className="map mb-lg-0 mb-5" style={{ height: props.mobile ? '50vh' : '100vh', width: '100%' }}>
            {mapenable && props.show &&
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: process.env.GATSBY_GOOGLE_MAP_KEY
                    }}
                    center={center} 
                    zoom={zoom}
                    yesIWantToUseGoogleMapApiInternals
                    options={{
                        fullscreenControl: false
                    }}
                    onGoogleApiLoaded={({ map, maps }) => myapiHasLoaded(map, maps, mapmarkers)} 
                >
                    {mapmarkers.map((pnt, ind) =>
                        <Marker key={ind} lat={pnt.lat} lng={pnt.lng} text={pnt.objectid} currentId={currentId} setCurrentId={setCurrentId} />
                    )}
                </GoogleMapReact>
            }
        </div>
    );
}

export default MapsInfiniteHits;